import React, { Dispatch, SetStateAction } from "react";
import { Video } from "vimeo";

export interface VideoSettingsState {
    video?: Video;
    hideSettingsViewHeading?: boolean;
}

// The argument passed to createContext simply mimics React's useState()
// semantics.
const VideoSettingsContext = React.createContext<
    [VideoSettingsState, Dispatch<SetStateAction<VideoSettingsState>>]
>([{}, () => {}]);

export default VideoSettingsContext;
